import React from "react";

const ToggleSwitch = React.forwardRef(function ToggleSwitch(
  { checked, onChange, label, disabled = false, className = "", ...props },
  ref
) {
  return <label className={`inline-flex min-h-9 cursor-pointer items-center gap-2 text-sm font-medium text-gray-700 ${disabled ? "cursor-not-allowed opacity-60" : ""} ${className}`}>
    <input ref={ref} type="checkbox" className="peer sr-only" checked={checked} onChange={onChange} disabled={disabled} {...props}/>
    <span aria-hidden="true" className={`relative h-5 w-9 rounded-full transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-blue-500 peer-focus-visible:ring-offset-2 ${checked ? "bg-blue-600" : "bg-gray-300"} ${disabled ? "bg-gray-200" : ""}`}>
      <span className={`absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform duration-200 ${checked ? "translate-x-4" : "translate-x-0"}`}/>
    </span>
    {label && <span>{label}</span>}
  </label>;
});

export default ToggleSwitch;
